var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fadeIn"}},[(_vm.loading)?_c('div',{staticClass:"loader-wrapper"},[_c('div',{staticClass:"loader-wrapper__bg",class:_vm.loaderColor})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }